<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('game.fraud_prevention_guide')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()" />
        </template>
      </van-nav-bar>
      <img class="imgfang" src="../../assets/img/fangpian.jpg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.push({ path: 'Game' });
    },
  },
};
</script>

<style>
.imgfang {
  width: 100%;
}
</style>
